module.exports = __webpack_public_path__ + "UMB HSA Beneficiary Form.pdf";